// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"e7ca6d8c","777":"a6479d4c"}[chunkId] + ".chunk.js";
};